import { Header } from './Header';
import { Footer } from './Footer';
import { MobileBottomNav } from './MobileBottomNav';
import { CreateFAB } from './CreateFAB';
import { PerformanceMonitor } from '@/components/dev/PerformanceMonitor';
import { AiIoDebugPanel } from '@/components/dev/AiIoDebugPanel';
import { MotionConfig } from 'framer-motion';
import { useLocation } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
  showFooter?: boolean;
}

export function Layout({ children, showFooter = true }: LayoutProps) {
  const location = useLocation();
  const isLanding = location.pathname === '/' || location.pathname === '/home';

  return (
    <MotionConfig reducedMotion="user">
      <div className="min-h-screen flex flex-col overflow-x-hidden">
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:start-4 focus:z-[100] focus:bg-primary focus:text-primary-foreground focus:px-4 focus:py-2 focus:rounded-lg focus:shadow-lg focus:text-sm focus:font-medium focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
        >
          Skip to main content
        </a>

        <Header />
        <main
          id="main-content"
          tabIndex={-1}
          className={`flex-1 focus:outline-none pb-16 md:pb-0 ${isLanding ? '' : 'pt-16 lg:pt-[4.5rem]'}`}
        >
          {children}
        </main>
        {showFooter && <Footer />}
        <MobileBottomNav />
        <CreateFAB />
        {import.meta.env.DEV && <PerformanceMonitor />}
        {import.meta.env.DEV && <AiIoDebugPanel />}
      </div>
    </MotionConfig>
  );
}
